<template>
  <v-container fluid class="align-center px-5">
    <v-card :style="cardStyle" flat class="align-center justify-center pt-0" :class="cardClass()">
      <v-card-title class="justify-center font-weight-bold">
        <mrx-translation token="app.views.track.prompt"></mrx-translation>
      </v-card-title>

      <v-card-text class="px-0 overflow-auto"
          ref="cardTextEl" @scroll="onScroll">
        <scroll-arrow
          id="tracks-scroll-arrow"
          :show="hasOverflow"
          :style="overlayStyle"
          :arrowAlignment="arrowAlignment"
          v-on:scrollDown="instantScroll('down')"
          v-on:scrollUp="instantScroll('up')"
        ></scroll-arrow>
        <multi-select
          id="tracks-selection"
          languagePath="tracks"
          v-model="tracks"
          :options="options"
          :onClick="set"
          >
        </multi-select>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
  import Bottom from '@/components/layouts/Bottom'
  import MultiSelect from '@/components/inputs/MultiSelect'
  import ScrollArrow from '../layouts/ScrollArrow.vue'
  import languageLogic from '@/mixins/languageLogic'
  import ui from '@/mixins/ui'
  import scrollArrow from '@/mixins/scrollArrow'
  import { mapGetters, mapActions } from 'vuex'

  export default {
    mixins: [languageLogic, ui, scrollArrow],
    components: { Bottom, MultiSelect, ScrollArrow },
    data() {
      return {
        options: {
          behavior: 'radio',
          template: 'list'
        }
      }
    },
    props: {
      maxHeightOffset: {
          type: Number,
          default: 0
        },
      initialMaxHeightOffset: {
        type: Number,
        default: 0
      }
    },
    computed: {
      tracks() {
        return this.all.map((x, i) => {
          return {
            id: x.id,
            name: x.name,
            selected: x.id === this.$store.state.v4.track.selected,
            value: x.id,
            options: x.options,
            path: x.path
          }

        })
      },
      cardStyle() {
        return {
          display: 'flex',
          flexDirection: 'column',
          maxHeight: 'calc(100vh - ' + this.initialMaxHeightOffset + 'px)'
        }
      },
      ...mapGetters({ all: 'v4/track/all' })
    },
    methods: {
      ...mapActions({ set: 'v4/track/set', next: 'v4/navigate/next' })
    },
    async mounted() {
      this.observedElement = this.$refs.cardTextEl
      this.observeForOverflow()

      await this.$store.dispatch('v4/reset')
      if (this.$store.getters['v4/track/single']) {
        await this.$store.dispatch('v4/track/set')
        this.next()
      }
    }
  }
</script>

<style scoped>
</style>
